var render, staticRenderFns
import script from "./SeverityBarChart.vue?vue&type=script&lang=js&"
export * from "./SeverityBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44be9006')) {
      api.createRecord('44be9006', component.options)
    } else {
      api.reload('44be9006', component.options)
    }
    
  }
}
component.options.__file = "src/views/dashboard/SeverityBarChart.vue"
export default component.exports